import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import * as Yup from "yup";
import CountriesCodes from "../profileOrganization/country_codes.json";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useDispatch } from "react-redux";
import {
  requestRegister,
  requestGoogleRegister,
} from "../../redux/actions/userActionCreators";
import { requestResponseInvitationRegister } from "../../redux/actions/confirmInvitationActionCreators";

import { useHistory } from "react-router-dom";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const Step3 = ({
  handleData,
  data,
  accountType,
  invitationUid,
  ssoUser,
  invitaionEnterprise,
  enterprise
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [notValid, setNotValid] = useState(false);
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState(false);
  // const interestList = [
  //   "cyber_risk_analysis",
  //   "creating_my_own_cyber_risk",
  //   "responding_security_questionnaires",
  //   "just_curious",
  //   "all_of_the_above",
  // ];

console.log({data})

  const formik = useFormik({
    initialValues: {
      country: data.country,
      enterprise: enterprise || data.enterprise,
      // interest: "",
      termsAndConditions: false,
    },
    validationSchema: Yup.object({
      country: Yup.string().required(t("required_field")),
      enterprise:
        !invitationUid &&
        accountType !== "free" &&
        (accountType === "enterprise"
          ? Yup.string()
              .required(t("required_field"))
              .test(
                "not-equal-to-cytailor",
                t("enterprise_must_not_equal_cytailor"),
                function (value) {
                  return (
                    value?.toLocaleUpperCase() !== this.resolve("CYTAILOR")
                  );
                }
              )
          : Yup.string().test(
              "not-equal-to-cytailor",
              t("enterprise_must_not_equal_cytailor"),
              function (value) {
                return value?.toLocaleUpperCase() !== this.resolve("CYTAILOR");
              }
            )),
      // interest: Yup.string().required(t("required_field")),
    }),
    onSubmit: () => {
      if (checked) {
        setError(false);
        if (data.phoneNumber && isValidPhoneNumber(data.phoneNumber)) {
          if (invitationUid) {
            if (ssoUser?.google_register) {
              dispatch(
                requestGoogleRegister(
                  ssoUser?.user_info?.email,
                  data.phoneNumber,
                  data.country,
                  invitaionEnterprise,
                  // data.interest,
                  checked,
                  accountType,
                  ssoUser?.token,
                  ssoUser?.refresh_token,
                  invitationUid,
                  null
                )
              );
            } else {
              dispatch(
                requestResponseInvitationRegister(
                  data,
                  checked,
                  invitationUid,
                  history
                )
              );
            }
          } else if (ssoUser?.google_register) {
            dispatch(
              requestGoogleRegister(
                ssoUser?.user_info?.email,
                data.phoneNumber,
                data.country,
                ssoUser?.enterprise || data.enterprise,
                // data.interest,
                checked,
                accountType,
                ssoUser?.token,
                ssoUser?.refresh_token,
                null,
                history
              )
            );
          } else {
            dispatch(requestRegister(data, checked, accountType, history));
          }
        } else {
          setNotValid(true);
        }
      } else {
        setError(true);
      }
    },
  });

  const handleChecked = (value) => {
    setChecked(value);
    setError(!value);
  };
  useEffect(() => {
    handleData(formik.values);
  }, [formik.values]);

  return (
    <form onSubmit={formik.handleSubmit}>
    {console.log("teststset", formik.values)}
      <Grid container spacing={3} sx={{ mt: 4 }}>
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {t("country")}
            <span style={{ color: "red" }}> *</span>
          </Typography>
          <Autocomplete
            onChange={(e, value) => formik.setFieldValue("country", value)}
            disablePortal
            id="combo-box-demo"
            options={CountriesCodes}
            getOptionLabel={(option) => t(option)}
            name="country"
            fullWidth
            error={Boolean(formik.touched.country && formik.errors.country)}
            helperText={formik.touched.country && formik.errors.country}
            onBlur={formik.handleBlur}
            value={formik.values.country}
            renderInput={(params) => <TextField {...params} />}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {t("phone_number")}
            <span style={{ color: "red" }}> *</span>
          </Typography>
          <PhoneInput
            international
            defaultCountry={data.country}
            onChange={(e) => handleData({ ...data, phoneNumber: e })}
            value={data.phoneNumber}
            name="phoneNumber"
          />
          {notValid &&
            (data.phoneNumber ? (
              isValidPhoneNumber(data.phoneNumber) ? undefined : (
                <div className="error-message">{t("invalid_phone_number")}</div>
              )
            ) : (
              <div className="error-message">{t("required_field")}</div>
            ))}
        </Grid>
        {!invitationUid && accountType !== "free" && (
          <Grid item xs={12}>
            <Typography variant="subtitle2">
              {t("company")}{" "}
              {accountType === "enterprise" && (
                <span style={{ color: "red" }}> *</span>
              )}
            </Typography>

            <TextField
              id="outlined-basic"
              placeholder={t("company")}
              name="enterprise"
              variant="outlined"
              fullWidth
              disabled={invitationUid}
              error={Boolean(
                formik.touched.enterprise && formik.errors.enterprise
              )}
              helperText={formik.touched.enterprise && formik.errors.enterprise}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.enterprise}
            />
          </Grid>
        )}

        {/* j'ai enleve le code la grid Interesse par */}

        {/* <Grid item xs={12}>
          <Typography variant="subtitle2">
            {t("what_are_you_interested_in")}{" "}
            <span style={{ color: "red" }}> *</span>
          </Typography>
          <FormControl fullWidth>
            <Select
              value={formik.values.interest}
              placeholder={`${t("what_are_you_interested_in")}...`}
              id="outlined-basic"
              variant="outlined"
              fullWidth
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              name="interest"
              error={Boolean(formik.touched.interest && formik.errors.interest)}
              helperText={formik.touched.interest && formik.errors.interest}
            >
              {interestList.map((interestItem) => (
                <MenuItem value={interestItem}>{t(interestItem)}</MenuItem>
              ))}
            </Select>
            <FormHelperText error="true">
              {Boolean(formik.touched.interest && formik.errors.interest) &&
                formik.errors.interest}
            </FormHelperText>
          </FormControl>
        </Grid> */}
        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel
              required
              control={
                <Checkbox
                  checked={checked}
                  onChange={(e) => handleChecked(e.target.checked)}
                  name="termsAndConditions"
                  error={true}
                />
              }
              label={
                <p>
                  {t("read_accept")}{" "}
                  <a
                    href="https://cytailor.io/service"
                    target="_blank"
                    id="register_link"
                  >
                    {t("cgu")}
                  </a>{" "}
                  {t("and")}{" "}
                  <a
                    href="https://cytailor.io/privacy"
                    target="_blank"
                    id="register_link"
                  >
                    {t("privacy_policy")}
                  </a>
                </p>
              }
            />
            {error && <p className="error-message">{t("error_message")}</p>}
          </FormGroup>
        </Grid>
      </Grid>

      <Button
        style={{ height: "50px", marginTop: "50px" }}
        color="secondary"
        variant="contained"
        fullWidth
        type="submit"
      >
        {t("create_profile")}
      </Button>
    </form>
  );
};

export default Step3;
